// 1. jquery.countTo
!(function (a) {
  "function" == typeof define && define.amd
    ? define(["jquery"], a)
    : a("object" == typeof exports ? require("jquery") : jQuery);
})(function (a) {
  function c(a, b) {
    return a.toFixed(b.decimals);
  }
  var b = function (c, d) {
    (this.$element = a(c)),
      (this.options = a.extend({}, b.DEFAULTS, this.dataOptions(), d)),
      this.init();
  };
  (b.DEFAULTS = {
    from: 0,
    to: 0,
    speed: 1e3,
    refreshInterval: 100,
    decimals: 0,
    formatter: c,
    onUpdate: null,
    onComplete: null,
  }),
    (b.prototype.init = function () {
      (this.value = this.options.from),
        (this.loops = Math.ceil(
          this.options.speed / this.options.refreshInterval
        )),
        (this.loopCount = 0),
        (this.increment = (this.options.to - this.options.from) / this.loops);
    }),
    (b.prototype.dataOptions = function () {
      var a = {
          from: this.$element.data("from"),
          to: this.$element.data("to"),
          speed: this.$element.data("speed"),
          refreshInterval: this.$element.data("refresh-interval"),
          decimals: this.$element.data("decimals"),
        },
        b = Object.keys(a);
      for (var c in b) {
        var d = b[c];
        "undefined" == typeof a[d] && delete a[d];
      }
      return a;
    }),
    (b.prototype.update = function () {
      (this.value += this.increment),
        this.loopCount++,
        this.render(),
        "function" == typeof this.options.onUpdate &&
          this.options.onUpdate.call(this.$element, this.value),
        this.loopCount >= this.loops &&
          (clearInterval(this.interval),
          (this.value = this.options.to),
          "function" == typeof this.options.onComplete &&
            this.options.onComplete.call(this.$element, this.value));
    }),
    (b.prototype.render = function () {
      var a = this.options.formatter.call(
        this.$element,
        this.value,
        this.options
      );
      this.$element.text(a);
    }),
    (b.prototype.restart = function () {
      this.stop(), this.init(), this.start();
    }),
    (b.prototype.start = function () {
      this.stop(),
        this.render(),
        (this.interval = setInterval(
          this.update.bind(this),
          this.options.refreshInterval
        ));
    }),
    (b.prototype.stop = function () {
      this.interval && clearInterval(this.interval);
    }),
    (b.prototype.toggle = function () {
      this.interval ? this.stop() : this.start();
    }),
    (a.fn.countTo = function (c) {
      return this.each(function () {
        var d = a(this),
          e = d.data("countTo"),
          f = !e || "object" == typeof c,
          g = "object" == typeof c ? c : {},
          h = "string" == typeof c ? c : "start";
        f && (e && e.stop(), d.data("countTo", (e = new b(this, g)))),
          e[h].call(e);
      });
    });
});

// 3. jquery.appear
!(function (a) {
  (a.fn.appear = function (b, c) {
    var d = a.extend({ data: void 0, one: !0, accX: 0, accY: 0 }, c);
    return this.each(function () {
      var c = a(this);
      if (((c.appeared = !1), !b)) return void c.trigger("appear", d.data);
      var e = a(window),
        f = function () {
          if (!c.is(":visible")) return void (c.appeared = !1);
          var a = e.scrollLeft(),
            b = e.scrollTop(),
            f = c.offset(),
            g = f.left,
            h = f.top,
            i = d.accX,
            j = d.accY,
            k = c.height(),
            l = e.height(),
            m = c.width(),
            n = e.width();
          h + k + j >= b && h <= b + l + j && g + m + i >= a && g <= a + n + i
            ? c.appeared || c.trigger("appear", d.data)
            : (c.appeared = !1);
        },
        g = function () {
          if (((c.appeared = !0), d.one)) {
            e.unbind("scroll", f);
            var g = a.inArray(f, a.fn.appear.checks);
            g >= 0 && a.fn.appear.checks.splice(g, 1);
          }
          b.apply(this, arguments);
        };
      d.one ? c.one("appear", d.data, g) : c.bind("appear", d.data, g),
        e.scroll(f),
        a.fn.appear.checks.push(f),
        f();
    });
  }),
    a.extend(a.fn.appear, {
      checks: [],
      timeout: null,
      checkAll: function () {
        var b = a.fn.appear.checks.length;
        if (b > 0) for (; b--; ) a.fn.appear.checks[b]();
      },
      run: function () {
        a.fn.appear.timeout && clearTimeout(a.fn.appear.timeout),
          (a.fn.appear.timeout = setTimeout(a.fn.appear.checkAll, 20));
      },
    }),
    a.each(
      [
        "append",
        "prepend",
        "after",
        "before",
        "attr",
        "removeAttr",
        "addClass",
        "removeClass",
        "toggleClass",
        "remove",
        "css",
        "show",
        "hide",
      ],
      function (b, c) {
        var d = a.fn[c];
        d &&
          (a.fn[c] = function () {
            var b = d.apply(this, arguments);
            return a.fn.appear.run(), b;
          });
      }
    );
})(jQuery);

// 4. jquery-css-skills-bar
/*!
 * https://github.com/umarwebdeveloper/jquery-css-skills-bar
 * Author: @umarwebdeveloper
 * Licensed under the MIT license
 */
!(function (a) {
  a.fn.skillBars = function (b) {
    var c = a.extend(
      {
        from: 0,
        to: !1,
        speed: 1e3,
        interval: 100,
        decimals: 0,
        onUpdate: null,
        onComplete: null,
        classes: {
          skillBarBar: ".skillbar-bar",
          skillBarPercent: ".skill-bar-percent",
        },
      },
      b
    );
    return this.each(function () {
      function j() {
        (e += g),
          h++,
          a(b)
            .find(c.classes.skillBarPercent)
            .text(e.toFixed(c.decimals) + "%"),
          "function" == typeof c.onUpdate && c.onUpdate.call(b, e),
          h >= f &&
            (clearInterval(i),
            (e = d),
            "function" == typeof c.onComplete && c.onComplete.call(b, e));
      }
      var b = a(this),
        d = 0 != c.to ? c.to : parseInt(b.attr("data-percent"));
      d > 100 && (d = 100);
      var e = c.from,
        f = Math.ceil(c.speed / c.interval),
        g = (d - e) / f,
        h = 0,
        i = setInterval(j, c.interval);
      b.find(c.classes.skillBarBar).animate(
        { width: parseInt(b.attr("data-percent")) + "%" },
        c.speed
      );
    });
  };
})(jQuery);

/**
 * General js
 */

/*
  1. preloader
  2. show elements
    2.1. page loaded
	2.2. page ready
  4. page BG
    4.1. page about BG
    4.2. page services BG
    4.3. page portfolio BG
    4.4. page contact BG
  5. to top arrow animation
    5.1. to top arrow scroll to top
  6. facts counter
  7. skills bar
  8. contact form
  10. contact modal
     contact modal additional CLOSER
*/

$(function () {
  "use strict";

  function handleLoad() {
    $(".preloader-bg").fadeOut(400);

    // show elements
    setTimeout(function () {
      $("body").addClass("page-loaded");
    }, 200);

    $("body").addClass("page-ready");
  }

  if (document.readyState === "complete") {
    // page is already loaded
    handleLoad();
  } else {
    $(window).on("load", handleLoad);
  }

  $(window).on("scroll", function () {
    // 4. page BG
    // 4.1. page about BG
    var topAbout = $("#about").offset().top;
    var setAbout = topAbout + 300;
    var bottomAbout = $("#about").offset().top + $("#about").outerHeight();
    var screenBottomAbout = $(window).scrollTop() + $(window).height();
    var screenTopAbout = $(window).scrollTop();
    if (screenBottomAbout > setAbout && screenTopAbout < bottomAbout) {
      $(".about-img-container").addClass("img-poster");
    } else {
      $(".about-img-container").removeClass("img-poster");
    }
    // 4.2. page services BG
    var topServices = $("#services").offset().top;
    var setServices = topServices + 300;
    var bottomServices =
      $("#services").offset().top + $("#services").outerHeight();
    var screenBottomServices = $(window).scrollTop() + $(window).height();
    var screenTopServices = $(window).scrollTop();
    if (
      screenBottomServices > setServices &&
      screenTopServices < bottomServices
    ) {
      $(".services-img-container").addClass("img-poster");
    } else {
      $(".services-img-container").removeClass("img-poster");
    }
    // 4.3. page portfolio BG
    var topPortfolio = $("#portfolio").offset().top;
    var setPortfolio = topPortfolio + 300;
    var bottomPortfolio =
      $("#portfolio").offset().top + $("#portfolio").outerHeight();
    var screenBottomPortfolio = $(window).scrollTop() + $(window).height();
    var screenTopPortfolio = $(window).scrollTop();
    if (
      screenBottomPortfolio > setPortfolio &&
      screenTopPortfolio < bottomPortfolio
    ) {
      $(".portfolio-img-container").addClass("img-poster");
    } else {
      $(".portfolio-img-container").removeClass("img-poster");
    }
    // 4.4. page contact BG
    var topContact = $("#contact").offset().top;
    var setContact = topContact + 300;
    var bottomContact =
      $("#contact").offset().top + $("#contact").outerHeight();
    var screenBottomContact = $(window).scrollTop() + $(window).height();
    var screenTopContact = $(window).scrollTop();
    if (screenBottomContact > setContact && screenTopContact < bottomContact) {
      $(".contact-img-container").addClass("img-poster");
    } else {
      $(".contact-img-container").removeClass("img-poster");
    }

    // 5. to top arrow animation
    if ($(this).scrollTop() > 500) {
      $(".to-top-arrow").addClass("show");
    } else {
      $(".to-top-arrow").removeClass("show");
    }
  });
  // 5.1. to top arrow scroll to top
  $(".scrollToTop, #menu-mobile-btn").on("click", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      800
    );
    return false;
  });

  // 6. facts counter
  $(".facts-counter-number").appear(function () {
    var count = $(this);
    count.countTo({
      from: 0,
      to: count.html(),
      speed: 1200,
      refreshInterval: 60,
    });
  });

  // 7. skills bar
  $(".show-skillbar").appear(function () {
    $(".skillbar").skillBars({
      from: 0,
      speed: 3000,
      interval: 100,
      decimals: 0,
    });
  });

  // 8. contact form
  $("form#form").on("submit", function () {
    $("form#form .error").remove();
    var s = !1;
    if (
      ($(".requiredField").each(function () {
        if ("" === jQuery.trim($(this).val()))
          $(this).prev("label").text(),
            $(this)
              .parent()
              .append('<span class="error">This field is required</span>'),
            $(this).addClass("inputError"),
            (s = !0);
        else if ($(this).hasClass("email")) {
          var r = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
          r.test(jQuery.trim($(this).val())) ||
            ($(this).prev("label").text(),
            $(this)
              .parent()
              .append('<span class="error">Invalid email address</span>'),
            $(this).addClass("inputError"),
            (s = !0));
        }
      }),
      !s)
    ) {
      $("form#form input.submit").fadeOut("normal", function () {
        $(this).parent().append("");
      });
      var r = $(this).serialize();
      $.post($(this).attr("action"), r, function () {
        $("form#form").slideUp("fast", function () {
          $(this).before(
            '<div class="success">Your email was sent successfully.</div>'
          );
        });
      });
    }
    return !1;
  });

  // 10. contact modal
  $(".contact-modal-launcher, .contact-modal-closer").on("click", function () {
    if ($(".contact-modal").hasClass("open")) {
      $(".contact-modal").removeClass("open").addClass("close");
    } else {
      $(".contact-modal").removeClass("close").addClass("open");
      $("#menu-mobile").removeClass("activated");
      $("#menu-mobile-caller").removeClass("lines-close");
    }
  });
  // contact modal additional CLOSER
  $("#menu-mobile-btn, .menu-nav li a").on("click", function () {
    $(".contact-modal").removeClass("open").addClass("close");
  });
});
